export default function initMarquee() {
    const container = document.querySelector(".fh-marquee");
    if (!container) return;

    const raw = container.dataset.items || "";
    const items = raw
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    if (!items.length) return;

    const track = container.querySelector(".fh-marquee-track");
    const sep = `<span class="fh-marquee-sep" aria-hidden="true">◆</span>`;
    const singleHtml = items
        .map((item) => `<span class="fh-marquee-item">${item}</span>${sep}`)
        .join("");

    // Render one set to measure its real pixel width after styles apply
    track.innerHTML = singleHtml;

    requestAnimationFrame(() => {
        const singleWidth = track.scrollWidth;

        // Fill the track with enough copies to stay visible across any viewport.
        // Animating by exactly singleWidth px always lands on an identical copy → seamless loop.
        const copies = Math.max(
            6,
            Math.ceil((window.innerWidth * 3) / singleWidth),
        );
        track.innerHTML = Array.from({ length: copies }, () => singleHtml).join(
            "",
        );
        track.style.setProperty("--fh-marquee-single", `-${singleWidth}px`);

        requestAnimationFrame(() => {
            track.style.animation = "fh-marquee 30s linear infinite";
        });
    });
}
